import { render, staticRenderFns } from "./UserListView.vue?vue&type=template&id=05a00066&scoped=true"
import script from "./UserListView.vue?vue&type=script&lang=js"
export * from "./UserListView.vue?vue&type=script&lang=js"
import style0 from "./UserListView.vue?vue&type=style&index=0&id=05a00066&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a00066",
  null
  
)

export default component.exports